"use strict";
var detectIncognito = require("detectincognitojs");
module.exports = function isIncognito() {
    return detectIncognito.detectIncognito();
};
